export default class App {
    constructor() {
        this.init();
    }

    init() {
        // eslint-disable-next-line no-console
        console.info("Child App Initialized");

        const backgroundImages = document.querySelectorAll<HTMLImageElement>(
            ".hero-special .swiper img"
        );

        // chhange url of backgroundimages[0] randomly with other images in the array on domcontentloaded

        if (backgroundImages.length <= 0) return;

        const randomImage = Math.floor(Math.random() * backgroundImages.length);
        const randomImageUrl = backgroundImages[randomImage].src;
        backgroundImages[0].src = randomImageUrl;
    }
}
